module.exports = __webpack_public_path__ + "img/Primary-chevron.964dee42.svg";